import { Component } from '@angular/core';

@Component({
  selector: 'psm-footer',
  templateUrl: 'footer.template.html'
})
export class FooterComponent { }



// WEBPACK FOOTER //
// ./src/app/components/common/footer/footer.component.ts